<script setup lang="ts">
import { NxtInput, NxtTabs } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useLanguagesStore } from '@/core/collections/languages/languages.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });

const languagesStore = useLanguagesStore();
const languages = computed(() => languagesStore.allLanguages.filter((lang) => jobBoard.value.language_ids?.includes(lang.id)));
const activeLanguage = ref(languages.value?.[0]);
</script>

<template>
   <section v-if="languages.length">
      <NxtTabs>
         <p
            v-for="language in languages"
            :key="language.id"
            :class="['language-tab', { '-active': language.id === activeLanguage?.id }]"
            @click="activeLanguage = language"
         >
            {{ language.iso_639_1.toUpperCase() }}
         </p>
      </NxtTabs>
      <p>{{ $t('job-board.settings.no-policy-url') }}</p>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="job-board_settings_privacy_policy"
               :label="$t('job-board.settings.privacy-policy')"
               v-model="jobBoard.privacy_policy[activeLanguage?.iso_639_1.toLowerCase()]"
            />
         </div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="job-board_settings_cookie_policy"
               :label="$t('job-board.settings.cookie-policy')"
               v-model="jobBoard.cookie_policy[activeLanguage?.iso_639_1.toLowerCase()]"
            />
         </div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="job-board_settings_terms_and_conditions"
               :label="$t('job-board.settings.terms-and-conditions')"
               v-model="jobBoard.terms_of_service[activeLanguage?.iso_639_1.toLowerCase()]"
            />
         </div>
      </div>
   </section>
   <p v-else>{{ $t('job-board.settings.no-languages-added') }}</p>
</template>

<style scoped lang="scss">
.language-tab {
   cursor: pointer;

   &.-active {
      color: var(--nxt-main);
      font-weight: 600;
   }
}
</style>
